import React from 'react'
import PropTypes from 'prop-types';

import Button from '../button/button'
class Anchor extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        label: PropTypes.string,
        href: PropTypes.string.isRequired
    }

    open() {
        window && window.open(this.props.href)
    }

    render() {
        let {label='', className=false, children=''} = this.props;

        className = className ? ' ' + className : ''

        return <div className={"form form-anchor" + className}>
            <Button onClick={this.open.bind(this)} icon='link' label={label}>{children}</Button>
        </div>
    }
}

export default Anchor

